import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProductList } from 'components/Cart/OrderSummary/HardwarePayment/ProductList/ProductList';
import { SubtotalTitle } from 'components/Cart/OrderSummary/SubtotalTitle/SubtotalTitle';

interface IHardwarePaymentProps {
  isCheckout?: boolean;
  isVermont?: boolean;
}

export const HardwarePayment: React.FC<IHardwarePaymentProps> = ({ isCheckout, isVermont = false }) => {
  const { t } = useTranslation();

  return (
    <>
      <SubtotalTitle summaryTitle={t('order-summary.due-today')} isCheckout={isCheckout} />
      <ProductList isVermont={isVermont} />
    </>
  );
};

HardwarePayment.displayName = 'HardwarePayment';
